import {HttpClient, HttpEvent, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {User} from '../../../shared/models/user.model';
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class CandidateDataService {
    constructor(private http: HttpClient) {
    }

    async convertToBase64(url: string): Promise<string> {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = error => reject(error);
        });
      }

    getUserData() {
        return this.http.get<User>('agri/getCurrentUserDetailsJob');
    }

    getCurrentUserInfo(){
        return this.http.get('agri/getCurrentUserInfo');
    }

    getCandidateProfileData(candidateId) {
        return this.http.get<User>('agri/getUserById?userId=' + candidateId)
    }

    updateUserData(userData){
        return this.http.put<User>('agri/updateUserJobBoard', userData);
    }

    updateIndexInformation(data, userId){
        return this.http.put('agri/crm/updateIndexInformation?userId=' + userId, data);
    }

}
